// import { vars } from '@theme'

export const styles = {
  global: (props: any) => ({
    '.react-ripples': {
      h: '100%',
      display: 'grid!important',
    },
    '.chakra-button': {
      borderStyle: 'none',
    },
  }),
}
